var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { setComponentTemplate } from '@ember/component';
import { inject as service } from '@ember/service';
import { hbs } from 'ember-cli-htmlbars';
import { emit, select } from '@banking/ui/services/card-management/reset-pin-modal';
import { setPinAction, toggleModalAction, userChangeConfirmPinAction, userChangePinAction, ValueError, Error as SetPinError } from '@banking/ui/workflows/card-settings/set-pin';
let ConnectedResetPin = (_dec = select(state => state.isOpen), _dec2 = select(state => state.confirmPin), _dec3 = select(state => state.confirmPinError?.[0]), _dec4 = select(state => state.pinError?.[0]), _dec5 = select(state => state.error?.[0]), _dec6 = select(state => state.pin), _dec7 = select(state => state.loading), (_class = class ConnectedResetPin extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "active", _descriptor2, this);
    _initializerDefineProperty(this, "confirmPinValue", _descriptor3, this);
    _initializerDefineProperty(this, "confirmPinError", _descriptor4, this);
    _initializerDefineProperty(this, "createPinError", _descriptor5, this);
    _initializerDefineProperty(this, "createPinScreenError", _descriptor6, this);
    _initializerDefineProperty(this, "createPinValue", _descriptor7, this);
    _initializerDefineProperty(this, "loading", _descriptor8, this);
  }
  get screenErrorMessage() {
    switch (this.createPinScreenError) {
      case SetPinError.GenericError:
        return this.intl.t('banking.checking.cardSettings.pin.error.generic');
      case SetPinError.InvalidPinMatch:
        return this.intl.t('banking.checking.cardSettings.pin.error.notMatch');
      case SetPinError.WeakPin:
        return this.intl.t('banking.checking.cardSettings.pin.error.weak');
      case undefined:
        return undefined;
      default:
        throw new Error('Unsupported error type');
    }
  }
  get confirmPinErrorMessage() {
    switch (this.confirmPinError) {
      case ValueError.InvalidLength:
        return this.intl.t('banking.checking.cardSettings.pin.error.validInput');
      case undefined:
        return undefined;
      default:
        throw new Error('Unsupported error type');
    }
  }
  get createPinErrorMessage() {
    switch (this.createPinError) {
      case ValueError.InvalidLength:
        return this.intl.t('banking.checking.cardSettings.pin.error.validInput');
      case undefined:
        return undefined;
      default:
        throw new Error('Unsupported error type');
    }
  }
  closeModal() {
    return toggleModalAction(false);
  }
  onConfirmPinChange(pin) {
    return userChangeConfirmPinAction(pin);
  }
  onCreatePinChange(pin) {
    return userChangePinAction(pin);
  }
  onSavePin() {
    return setPinAction();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "confirmPinValue", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "confirmPinError", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "createPinError", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "createPinScreenError", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "createPinValue", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "loading", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "closeModal", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmPinChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmPinChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreatePinChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onCreatePinChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSavePin", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSavePin"), _class.prototype)), _class));
export { ConnectedResetPin as default };
setComponentTemplate(hbs`
   <Banking::Checking::CardSettings::ResetPin
     @active={{this.active}}
     @closeModal={{this.closeModal}}
     @createPinValue={{this.createPinValue}}
     @confirmPinValue={{this.confirmPinValue}}
     @createPinErrorMessage={{this.createPinErrorMessage}}
     @confirmPinErrorMessage={{this.confirmPinErrorMessage}}
     @createPinScreenErrorMessage={{this.screenErrorMessage}}
     @isLoading={{this.loading}}
     @onCreatePinChange={{this.onCreatePinChange}}
     @onConfirmPinChange={{this.onConfirmPinChange}}
     @onSavePin={{this.onSavePin}}
   />
  `, ConnectedResetPin);